import React, { FC } from 'react';
import { ExpandableOverlayModel } from '../../models/ExpandableOverlay.model';
import { TExpandableOverlayProps } from '../../types/ExpandableOverlay';
import Gallery from './gallery';
import ExpandableOverlayVideoModal from './videoModal';
import './styles.scss';

const ExpandableOverlay: FC<TExpandableOverlayProps> = (props) => {
  const model = new ExpandableOverlayModel(props);

  return (
    <div className="series-overview-expandable-overlay__wrapper" >
      {
      // model.video ?
      //   <ExpandableOverlayVideoModal videoUrl={model.video} videoDescription={model.videoDescription} title={model.title} /> :
        model.slides ?
          <Gallery slides={model.slides} title={model.title} description={model.description} /> : null
      }
    </div>
  )
}

export default ExpandableOverlay;